<template>
  <component
    :is="tag"
    class="c-btn"
    :class="btnClass"
    :type="tag === 'button' ? nativeType : null"
    :disabled="tag === 'button' ? isDisabled : null"
    :aria-disabled="isDisabled ? 'true' : null"
    :aria-busy="loading ? 'true' : null"
    :to="tag === 'router-link' ? to : null"
    :href="hrefAttr"
    @click="onClick"
  >
    <span v-if="loading" class="c-btn__spin" aria-hidden="true"></span>
    <calm-icon v-else-if="icon" :name="icon" :size="iconSize" />
    <slot />
  </component>
</template>

<script>
import CalmIcon from "./CalmIcon.vue";

export default {
  name: "calm-button",
  components: { CalmIcon },
  props: {
    variant: {
      type: String,
      default: "primary",
      validator: (v) => ["primary", "soft", "ghost", "outline", "danger"].indexOf(v) !== -1,
    },
    size: {
      type: String,
      default: "md",
      validator: (v) => ["md", "sm"].indexOf(v) !== -1,
    },
    icon: { type: String, default: "" },
    iconOnly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    tag: {
      type: String,
      default: "button",
      validator: (v) => ["button", "a", "router-link"].indexOf(v) !== -1,
    },
    nativeType: { type: String, default: "button" }, // submit | button | reset
    to: { type: [String, Object], default: null }, // router-link target
    href: { type: String, default: null }, // <a> target
  },
  computed: {
    isDisabled() {
      return this.disabled || this.loading;
    },
    iconSize() {
      return this.size === "sm" ? 14 : 15;
    },
    hrefAttr() {
      if (this.tag !== "a") return null;
      // keep <a> non-navigable while disabled
      return this.isDisabled ? null : this.href;
    },
    btnClass() {
      return [
        "c-btn--" + this.variant,
        this.size === "sm" ? "c-btn--sm" : null,
        this.iconOnly ? "c-btn--icon" : null,
        this.isDisabled && this.tag !== "button" ? "is-disabled" : null,
      ];
    },
  },
  methods: {
    onClick(e) {
      // for non-<button> tags the native disabled attr doesn't apply — guard here
      if (this.isDisabled) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      this.$emit("click", e);
    },
  },
};
</script>
